// extracted by mini-css-extract-plugin
export default {"root":"root___T4h3B","hoverable":"hoverable___nwEpH","body":"body___jqIHu","image":"image___bbsCv","label":"label___iHAw5"};